import { render, staticRenderFns } from "./canteen.vue?vue&type=template&id=20654824&scoped=true"
import script from "./canteen.vue?vue&type=script&lang=js"
export * from "./canteen.vue?vue&type=script&lang=js"
import style0 from "./canteen.vue?vue&type=style&index=0&id=20654824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20654824",
  null
  
)

export default component.exports